import { render, staticRenderFns } from "./Appraisal-Acknowledgement-Page.vue?vue&type=template&id=888efe50&"
import script from "./Appraisal-Acknowledgement-Page.vue?vue&type=script&lang=js&"
export * from "./Appraisal-Acknowledgement-Page.vue?vue&type=script&lang=js&"
import style0 from "./Appraisal-Acknowledgement-Page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Temp Code/HRM/hrm_front-end/hrm-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTimeline } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VFlex,VIcon,VLayout,VTab,VTabItem,VTabs,VTimeline,VTimelineItem})
